import React, { useState, useEffect, Fragment } from "react";
import CompanyDropDown from "../../crm/CompanyDropDown";

export default function CompanyFilter({ company_id, onChange }) {
  return (
    <Fragment>
      <label>{I18n.t("company")}</label>
      <CompanyDropDown 
        value={company_id}
        onChange={company_id => onChange(company_id)} 
      />
    </Fragment>
  );
}
